/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { contactFieldSignalResponseDtoSchema } from "./contactFieldSignalResponseDtoSchema";
import { contactMultiValueItemResponseDtoSchema } from "./contactMultiValueItemResponseDtoSchema";
import { z } from "zod/v4";

export const pendingContactChangesetDtoSchema = z.object({
    "tenantId": z.optional(z.string()),
"firstName": z.string().nullish(),
"lastName": z.string().nullish(),
"fullName": z.string().nullish(),
"preferredName": z.string().nullish(),
get "email"(){
                return z.array(contactMultiValueItemResponseDtoSchema).nullish()
              },
get "phone"(){
                return z.array(contactMultiValueItemResponseDtoSchema).nullish()
              },
get "links"(){
                return z.array(contactMultiValueItemResponseDtoSchema).nullish()
              },
"company": z.string().nullish(),
"title": z.string().nullish(),
"timezone": z.string().nullish(),
"address": z.string().nullish(),
"city": z.string().nullish(),
"state": z.string().nullish(),
"postalCode": z.string().nullish(),
get "contactFieldSignals"(){
                return z.array(contactFieldSignalResponseDtoSchema).optional()
              }
    })